export interface Person {
  id: string;
  firstName: string;
  surnames: string;
  personTypeName: string;
  personTypeCode: string | null;
  dob: string | null;
  cin: string | null;
  phoneNumber: string | null;
  /** Staff job title, synced from the client's systems (JCCA-163). */
  jobTitle?: string | null;
  /** Client administrative payor, synced from the client's systems (JCCA-166). */
  adminPayor?: string | null;
}

/** What is shown next to a person's name: the client's admin payor or the staff member's job title. */
export function personTagline(p: { jobTitle?: string | null; adminPayor?: string | null }): string {
  return p.adminPayor?.trim() || p.jobTitle?.trim() || '';
}

export interface PersonDetail extends Person {
  personTypeId: string | null;
  personRecordOriginId: string | null;
  personRecordOriginName: string | null;
  /** Whether the person can be edited, by record origin (only manual entries by default). */
  isEditable?: boolean;
  sex: string | null;
  medicaidCIN: string | null;
  hrFileNumber: string | null;
  // Integration keys, not editable in the UI but must be echoed back on update.
  hrisId: string | null;
  evolvPeopleId: string | null;
  estherClientKey: number | null;
}

export interface PersonType {
  id: string;
  name: string;
  personTypeCode: string | null; // e.g. CL = client, JS = staff
}

export interface PersonsResponse {
  persons: Person[];
  total: number;
}

export interface PersonRecordOrigin {
  id: string;
  name: string;
}

export interface PersonFilterParams {
  pageSize?: number;
  pageIndex?: number;
  /** Matches first name or surnames only. */
  filter?: string;
  /** Matches first name, surnames or Medicaid CIN (the API ignores `filter` when this is set). */
  search?: string;
  personTypeCode?: string;
  excludePersonTypeCode?: string;
}

export interface CreatePersonPayload {
  firstName: string;
  surnames: string;
  dob?: string | null;
  sex?: string | null;
  phoneNumber?: string | null;
  medicaidCIN?: string | null;
  hrFileNumber?: string | null;
  personTypeId?: string | null;
  personRecordOriginId?: string | null;
}

export interface UpdatePersonPayload {
  id: string;
  personTypeId: string | null;
  personRecordOriginId: string | null;
  firstName: string;
  surnames: string;
  phoneNumber: string | null;
  dob: string | null;
  sex: string | null;
  // The API maps the whole DTO onto the entity: omitting any of these would wipe it.
  medicaidCIN: string | null;
  hrFileNumber: string | null;
  hrisId: string | null;
  evolvPeopleId: string | null;
  estherClientKey: number | null;
}
